import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ActivityDisplayDTO} from '../models/utilisation/pha/ActivityDisplayDTO';
import {UtilisationPhaResponseDTO} from '../models/utilisation/UtilisationPhaResponseDTO';
import {UtilisationMedschemeResponseDTO} from '../models/utilisation/UtilisationMedschemeResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private url = environment.baseClmUrl + '/activity';
  private ignUtilizationUrl = environment.baseIgnUrl + '/utilisation';

  constructor(private httpClient: HttpClient) {
  }

  getListOfBothAdminActivities(pagedRequestDTO: PagedRequestDTO, productCode: string): Observable<UtilisationPhaResponseDTO | UtilisationMedschemeResponseDTO> {
    const parameters = `?productCode=${productCode}`;
    return this.httpClient.post<UtilisationPhaResponseDTO | UtilisationMedschemeResponseDTO>(this.ignUtilizationUrl + '/filter' + parameters, pagedRequestDTO);
  }

  getListOfActivities(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ActivityDisplayDTO>> {
    return this.httpClient.post<PagedResponseDTO<ActivityDisplayDTO>>(this.url + '/filter', pagedRequestDTO);
  }
}
